import OperatingViewOperator from '@/module/monitoringCenter/page/operatingView_operator.vue'
import OperatingViewScreen from '@/module/monitoringCenter/page/operatingView_screen.vue'
import DataVisual from '@/module/monitoringCenter/page/dataVisual.vue'
import layout from '@/layout/index'
import i18n from '../../../lang/index'
// 导出配置的路由器
export default [{
        path: '/monitoringCenter',
        component: layout,
        redirect: 'monitoringCenter/operatingView_operator',
        meta: { title: i18n.t('monitoringCenter.monitor'), icon: 'icon-yunwei', perms: ['bee:monitor'] },
        children: [{
                path: 'operatingView_screen',
                redirect: '/monitoringCenter/screen',
                meta: {
                    title: i18n.t('yun-ying-zong-lan-zong-jian-kong-ping'),
                    icon: 'icon-yunwei',
                    perms: ['bee:order:screen']
                },
                extra: { isLink: true, linkType: 'in' }
            },
            {
                path: 'operatingView_operator',
                component: OperatingViewOperator,
                meta: { title: i18n.t('yun-ying-zong-lan-yun-ying-shang-ban'), icon: 'icon-yingxiao1', perms: ['bee:order:operatorScreen'] }
            },
            {
                path: 'dataVisual',
                component: DataVisual,
                meta: { title: i18n.t('monitoringCenter.dataVisual'), icon: 'icon-shuju', perms: ['bee:res:dataView'] },
                hidden: true
            }
        ]
    },
    {
        path: '/monitoringCenter/screen',
        component: OperatingViewScreen,
        hidden: true
    }
]


// WEBPACK FOOTER //
// ./src/module/monitoringCenter/router/index.js